import { transformCurrencyAmountDto } from './currency-amount';
export const transformCustomShipmentDto = _ref => {
  let {
    prices
  } = _ref;
  return {
    prices: {
      minimum: transformCurrencyAmountDto(prices.minimum),
      maximum: transformCurrencyAmountDto(prices.maximum)
    }
  };
};